/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import InputGroup from '../../components/bootstrap/forms/InputGroup';
import Input from '../../components/bootstrap/forms/Input';
import Button from '../../components/bootstrap/Button';
import GoldImage from '../../assets/img/goldImageSmall.png';
import FormGroup from '../../components/bootstrap/forms/FormGroup';
import { validateGoldPriceUpdate } from '../helper/Login/loginValidates';
import {
	updateTodayGoldPriceStart,
	updateTodayGoldPriceResponseResetStart,
} from '../../redux/general/general.action';

import { selectUpdateTodayGoldPriceResponse } from '../../redux/general/general.selector';
import { getLoginObjDetails } from '../../redux/login/login.selector';
import { loginPages } from '../../menu';
import '../../styles/login/login.scss';
import showAlert from '../_common/SwalAlert';

const GoldPriceUpdateComponent = () => {
	const dispatch = useDispatch();
	const loginData = useSelector(getLoginObjDetails);
	const navigate = useNavigate();

	const updateTodayGoldPriceResp = useSelector(selectUpdateTodayGoldPriceResponse);

	const {
		userID,
		userName,
		userAccessBranchID,
		infogCompanyID,
		companyID,
		databaseName,
		isNbfcLogin,
		userRole,
		userLevel,
		companyModal,
	} = loginData;

	const formik = useFormik({
		initialValues: {
			goldPrice24k: '',
			goldPrice22k: '',
			goldPrice20k: '',
			goldPrice18k: '',
			goldPrice16k: '',
			goldRateUpdate: 0,
			companyID,
			userID,
			userName,
			userAccessBranchID,
			infogCompanyID,
			databaseName,
			isNbfcLogin,
			userRole,
			userLevel,
			companyModal,
		},
		validate: validateGoldPriceUpdate,
		onSubmit: (values) => {
			dispatch(updateTodayGoldPriceStart(values));
		},
	});

	function swalComponent(title: string, text: string, icon: any) {
		showAlert({ title, text, icon });
	}
	useEffect(() => {
		if (updateTodayGoldPriceResp !== null && updateTodayGoldPriceResp !== undefined) {
			if (updateTodayGoldPriceResp.statusCode === '01') {
				swalComponent('Success', `Gold Price Updated`, 'success');
				navigateDashoard();
			} else {
				swalComponent(
					'Cancelled',
					'Something went worng. Please try after sometime.',
					'error',
				);
			}
			dispatch(updateTodayGoldPriceResponseResetStart());
		}
	}, [updateTodayGoldPriceResp]);

	const navigateDashoard = () => {
		// Check if user is SuperAdmin and redirect to company page instead of dashboard
		if (loginData.userType === 'SuperAdmin') {
			navigate('/company-pages/company');
		} else {
			// Original dashboard navigation for non-SuperAdmin users
			navigate(loginPages.dashboard.path);
		}
	};
	return (
		<div className='gold-price-form'>
			<div className='gold-price-header'>
				<img src={GoldImage} className='gold-imgMain' alt='Gold' />
				<h2 className='gold-price-title'>Today's Gold Price</h2>
			</div>

			<form onSubmit={formik.handleSubmit} className='gold-price-form-content'>
				<div className='row g-3'>
					<div className='col-12 col-md-6'>
						<FormGroup id='goldPrice24k' label='24K Gold Price / Gram'>
							<InputGroup className='gold-price-input-group'>
								<img src={GoldImage} className='gold-img' alt='Gold' />
								<Input
									type='tel'
									autoComplete='tel'
									name='goldPrice24k'
									placeholder='Enter Price'
									onChange={formik.handleChange}
									value={formik.values.goldPrice24k.replace(/[^0-9]/g, '')}
									isValid={formik.isValid}
									isTouched={formik.touched.goldPrice24k}
									invalidFeedback={formik.errors.goldPrice24k}
									validFeedback=''
									className='gold-price-input'
								/>
							</InputGroup>
						</FormGroup>
					</div>
					<div className='col-12 col-md-6'>
						<FormGroup id='goldPrice22k' label='22K Gold Price / Gram'>
							<InputGroup className='gold-price-input-group'>
								<img src={GoldImage} className='gold-img' alt='Gold' />
								<Input
									type='tel'
									autoComplete='tel'
									name='goldPrice22k'
									placeholder='Enter Price'
									onChange={formik.handleChange}
									value={formik.values.goldPrice22k.replace(/[^0-9]/g, '')}
									isValid={formik.isValid}
									isTouched={formik.touched.goldPrice22k}
									invalidFeedback={formik.errors.goldPrice22k}
									validFeedback=''
									className='gold-price-input'
								/>
							</InputGroup>
						</FormGroup>
					</div>
					<div className='col-12 col-md-6'>
						<FormGroup id='goldPrice20k' label='20K Gold Price / Gram'>
							<InputGroup className='gold-price-input-group'>
								<img src={GoldImage} className='gold-img' alt='Gold' />
								<Input
									type='tel'
									autoComplete='tel'
									name='goldPrice20k'
									placeholder='Enter Price'
									onChange={formik.handleChange}
									value={formik.values.goldPrice20k.replace(/[^0-9]/g, '')}
									isValid={formik.isValid}
									isTouched={formik.touched.goldPrice20k}
									invalidFeedback={formik.errors.goldPrice20k}
									validFeedback=''
									className='gold-price-input'
								/>
							</InputGroup>
						</FormGroup>
					</div>
					<div className='col-12 col-md-6'>
						<FormGroup id='goldPrice18k' label='18K Gold Price / Gram'>
							<InputGroup className='gold-price-input-group'>
								<img src={GoldImage} className='gold-img' alt='Gold' />
								<Input
									type='tel'
									autoComplete='tel'
									name='goldPrice18k'
									placeholder='Enter Price'
									onChange={formik.handleChange}
									value={formik.values.goldPrice18k.replace(/[^0-9]/g, '')}
									isValid={formik.isValid}
									isTouched={formik.touched.goldPrice18k}
									invalidFeedback={formik.errors.goldPrice18k}
									validFeedback=''
									className='gold-price-input'
								/>
							</InputGroup>
						</FormGroup>
					</div>
					<div className='col-12'>
						<FormGroup id='goldPrice16k' label='16K Gold Price / Gram'>
							<InputGroup className='gold-price-input-group'>
								<img src={GoldImage} className='gold-img' alt='Gold' />
								<Input
									type='tel'
									autoComplete='tel'
									name='goldPrice16k'
									placeholder='Enter Price'
									onChange={formik.handleChange}
									value={formik.values.goldPrice16k.replace(/[^0-9]/g, '')}
									isValid={formik.isValid}
									isTouched={formik.touched.goldPrice16k}
									invalidFeedback={formik.errors.goldPrice16k}
									validFeedback=''
									className='gold-price-input'
								/>
							</InputGroup>
						</FormGroup>
					</div>
					<div className='col-12'>
						<Button
							color='primary'
							type='submit'
							className='gold-price-update-btn'
							onClick={formik.handleSubmit}>
							UPDATE
						</Button>
					</div>
				</div>
			</form>
		</div>
	);
};
export default GoldPriceUpdateComponent;
